import { inject, Injector } from '@angular/core';
import {ActivatedRouteSnapshot } from '@angular/router';
import { from, map, switchMap } from 'rxjs';
import { CommunitySignalService } from '../services/community/community.signal.service';
import { UserRoleEnum } from '../enums/userrole.enum';
import { PlatformService } from '../services/platform.service';
import { AuthStateService } from '../services/auth-state.service';

export const CommunityUserResolver = (route: ActivatedRouteSnapshot) => {
  const injector = inject(Injector);
  const platformService = inject(PlatformService);
  const communitySIgnalService = inject(CommunitySignalService);
  const byPassRoles = [UserRoleEnum.AdminAllowImpersonation];

  if (!platformService.browser()) return false;


  return from(import('@auth0/auth0-angular'))
  .pipe(
    map(module => module.AuthService),
    switchMap((AuthService) => {
      const service = injector.get(AuthService);
      return service.user$;
    }),
    map((user) => {
      const id = `${route.paramMap.get('id')}`;

      if (byPassRoles.includes(user?.['https://seemylegacy.com/sml_role'])) {
        communitySIgnalService.signalIsValidCommunityUser.set(true);
        return true;
      }

      const communityId = `${user?.['https://seemylegacy.com/community_id']}`;
      if (user && id && communityId === id) {
        communitySIgnalService.signalIsValidCommunityUser.set(true);
        return true;
      }
      communitySIgnalService.signalIsValidCommunityUser.set(false);
      return false;
    }),
  );
};